import React from "react";
import ReactDOM from "react-dom/client";

import { GlobalStyle } from "./styled";

import App from "./App";
import Orders from "./Orders";
import Alert from "./Alert";

/* uncomment for testing locally
window.appsuiteSettings = {
	id: "giftcard", // giftcard, orders (local only)
	location: "hospitality",
	brand: "mapleandash", // hospitality, mapleandash, monarch, kessaku, marisella
};*/

let element;
let id;
let brand;

if (document.getElementById("appsuite-root")) {
	const root = ReactDOM.createRoot(document.getElementById("appsuite-root"));
	if (root) {
		if (window.appsuiteSettings) {
			id = window.appsuiteSettings.id;
			brand = window.appsuiteSettings.brand;

			id === "giftcard"
				? (element = <App brand={brand} />)
				: id === "orders"
				? (element = <Orders brand={brand} />)
				: (element = (
						<Alert data={{ type: "notice", text: "Page under development." }} />
				  ));
		} else {
			element = (
				<Alert data={{ type: "error", text: "An error has occurred." }} />
			);
		}

		root.render(
			<React.StrictMode>
				<GlobalStyle brand={brand} />
				{element}
			</React.StrictMode>,
		);
	}
}
